import { Container, Text, Spacer } from "@nextui-org/react";
import { useParams } from "react-router-dom";
import { WorkshopSteps, StepConfig } from "../../components/WorkshopSteps/WorkshopSteps";
import stateMachineDemo from "../../../config/stateMachineDemo.json";

const WorkshopStepsPage = () => {
    const { workshopId } = useParams();

    // Cast the imported JSON to the expected type
    const config = stateMachineDemo as Record<string, StepConfig>;

    return (
        <Container display="flex" direction="column" css={{ minHeight: "100vh", padding: "20px" }}>
            <Text h3>Workshop Steps: {workshopId}</Text>
            <Spacer y={1} />
            <div style={{ width: '100%', height: 'calc(100vh - 100px)' }}>
                <WorkshopSteps config={config} />
            </div>
        </Container>
    );
};

export default WorkshopStepsPage;
